<template>
  <div>
    <div class="flex text-left p-4">
      <span class="flex items-center">
        <i class="fas fa-layer-group pr-2" />
        {{ title }}
      </span>
    </div>
    <div class="px-4 text-xs font-extralight text-left" :class="!collapsed ? 'h-auto' : 'h-0 overflow-hidden'">
      <div v-if="features.length">
        <div class="flex justify-between border-1 rounded-t px-1 bg-gray-500/90 text-white">
          ({{ featureIndex + 1 }} of {{ features.length }})
          <div class="flex items-center">
            <p class="group" v-if="featureIndex">
              <button
                class="focus:outline-none"
                @click="featureIndex--"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="previous feature"
              >
                <i class="fas fa-caret-left" />
              </button>
            </p>
            <p class="group">
              <span class="">
                <button
                  class="focus:outline-none"
                  @click="featureIndex++"
                  :disabled="featureIndex + 1 >= features.length"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="next feature"
                >
                  <i class="fas fa-caret-right" />
                </button>
              </span>
            </p>
          </div>
        </div>
        <div class="border-1 rounded">
          <div class="pl-2 font-bold border-b-1 border-gray-500">
            {{ features[featureIndex].id_ ? features[featureIndex].id_ : features[featureIndex].ol_uid }}
          </div>
          <div class="max-h-50 pl-2 overflow-auto text-xs">
            <div v-for="(property, key) in getAttributes" :key="key">
              <span class="font-bold">{{ key }}:</span> <span class="font-normal">{{ property }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>No Features Found</div>
    </div>
  </div>
</template>

<script>
import { onBeforeUnmount, ref, watch } from 'vue'

export default {
  name: 'IdentifyItem',
  props: {
    features: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const featureIndex = ref(0)
    const collapsed = ref(false)

    const toggleCollapse = () => {
      collapsed.value = !collapsed.value
    }

    const unWatchFeatures = watch(
      () => props.features,
      () => {
        featureIndex.value = 0
      }
    )

    onBeforeUnmount(() => {
      unWatchFeatures()
    })

    return { featureIndex, collapsed, toggleCollapse }
  },
  computed: {
    getAttributes() {
      const unordered =
        this.features[this.featureIndex].properties ||
        this.features[this.featureIndex].properties_ ||
        this.features[this.featureIndex]?.getProperties()
      const keys = Object.keys(unordered).filter((val) => val !== 'geometry')
      const ordered = keys.sort().reduce((obj, key) => {
        obj[key] = unordered[key]
        return obj
      }, {})
      return ordered
    },
  },
}
</script>
